<template>
  <div class="App-Lef-Nav">
    <div class="App-Lef-Nav-W">
      <el-space direction="vertical" :size="60" alignment="center" w-100 fill>
        <!-- Top Logo Section -->
        <app-logo :size="30"></app-logo>
        <!-- Main Navigation -->
        <div>
          <!-- Top Main -->
          <div class="App-Lef-Nav-W-M">
            <el-menu router>
              <el-menu-item index="users">
                <i class="el-icon-user"></i>
                <span>Users</span>
              </el-menu-item>
              <!--  -->
              <el-menu-item index="startups">
                <i class="el-icon-office-building"></i>
                <span>Startups</span>
              </el-menu-item>
              <!--  -->
              <el-menu-item index="opportunities">
                <i class="el-icon-s-opportunity"></i>
                <span>Opportunities</span>
              </el-menu-item>
              <!--  -->
              <el-menu-item index="biddings">
                <i class="el-icon-document"></i>
                <span>Bids</span>
              </el-menu-item>
              <!--  -->
              <el-menu-item index="transactions">
                <i class="el-icon-document"></i>
                <span>Transactions</span>
              </el-menu-item>
              <!--  -->
              <el-divider />
              <!--  -->
              <el-menu-item index="invitations">
                <i class="el-icon-check"></i>
                <span>Invitations</span>
              </el-menu-item>
            </el-menu>
          </div>
          <!--  -->
          <el-divider />
          <!-- Bottom Main -->
          <div class="App-Lef-Nav-W-S">
            <div>
              <app-account-top :user="user"  />
              <el-menu v-if="false">
                <!--  -->
                <el-menu-item index="3">
                  <span>Account</span>
                </el-menu-item>
                <!--  -->
                <el-menu-item index="3">
                  <span>Logout</span>
                </el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
        <!--  -->
        <div></div>
      </el-space>
    </div>
    <!--  -->
    <div style="padding: 15px 10px">
      <app-footer txt-center></app-footer>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},

})
export default class extends Vue {
  get user() {
    return this.$store.state.account.user;
  }
}
</script>

<style lang="scss">
.App-Lef-Nav {
  min-height: 100vh;
  width: 100%;
  max-width: 400px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: nowrap;

  // white section
  .App-Lef-Nav-W {
    border-radius: var(--el-border-radius-base) !important;
    background: white;
    padding: map.get($--button-padding-vertical, "large") * 1.5
      map.get($--button-padding-vertical, "large") * 1.5
      map.get($--button-padding-vertical, "large") * 1.5
      map.get($--button-padding-vertical, "large") * 1.5;
    min-height: 500px;
    margin-bottom: map.get($--button-padding-vertical, "large");
    display: block;
    max-width: 340px;
    margin: 0 auto;

    .el-menu-item {
      min-width: 60%;
      display: inline-block;
      border-radius: 30px;
    }
    .el-space {
      min-height: 500px;
    }
    .App-Logo {
      margin-left: 8px;
    }
  }
  //
  .el-divider--horizontal {
    margin: 18px 20px;
    opacity: 0.4;
    max-width: 100px;
  }
}
//
</style>
